<template>
    <div>
        <o-field label="Application Type *" :type="fieldType('type')" :message="getError('type')">
            <o-select placeholder="Application Type" :model-value="form.type" @update:modelValue="form.type = $event" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="type in filingApplicationTypes"
                    :value="type.id"
                    :key="type.id">
                    {{ type.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Review Type *" :type="fieldType('filing_status')" :message="getError('filing_status')">
            <o-select placeholder="Select a status" :model-value="form.filing_status" @update:modelValue="form.filing_status = $event" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in filingFilingStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Work Types *" :type="fieldType('work_types')" :message="getError('work_types')">
            <multiselect
                    v-model="selectedWorkTypes"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    :options="workTypes"
                    :mode="'tags'"
                    track-by="title"
                    placeholder="Pick Work Types"
                    label="title"
                    value-prop="id"
                    :object="true"
                    @input="$emit('submitting', true)"
            />
        </o-field>

        <o-field label="Job # *" :type="fieldType('dob_job_number')" :message="getError('dob_job_number')">
            <o-input placeholder="Job #" v-model="form.dob_job_number"/>
        </o-field>

        <o-field label="Floor(s) *" :type="fieldType('floors')" :message="getError('floors')">
            <o-input placeholder="Floor(s)" v-model="form.floors"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a Status" :model-value="form.status" @update:modelValue="form.status = $event" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in filingStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import Multiselect from '@vueform/multiselect'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            Multiselect
        },

        mixins: [Application, HandlesForm],

        data () {
            return {
                selectedWorkTypes: [],
                form: {
                    dob_job_number: null,
                    filing_status: null,
                    work_types: null,
                    floors: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters([
                'filingApplicationTypes',
                'filingFilingStatuses',
                'filingStatuses',
                'workTypesByIds',
                'workTypes'
            ])
        },

        watch: {
            selectedWorkTypes (workTypes) {
                this.form.work_types = _.map(workTypes, (workType) => workType.id)
            }
        },

        mounted () {
          if(this.application.length > 0) {
            this.selectedWorkTypes = this.workTypesByIds(this.application.work_types)
          }
        }
    }
</script>
